/**
 * 오디오 블록 (FP-4) — BlockNote `audio` 블록 렌더/직렬화.
 * { type:"audio", props:{ url, name? }, content:[], children:[] }
 * <audio controls controlsList=nodownload>. 우클릭 차단.
 */

import { neutralizeUrl } from "../../utils/url.js";

export function audioBlockToElement(block) {
  if (typeof document === "undefined") throw new Error("audioBlockToElement: DOM 필요");
  const el = document.createElement("div");
  el.className = "block";
  el.dataset.type = "audio";
  if (block && block.id != null) el.dataset.id = String(block.id);
  el.__props = block && block.props ? { ...block.props } : {};
  el.__children = block && Array.isArray(block.children) ? block.children : [];

  const props = el.__props;
  const wrap = document.createElement("div");
  wrap.className = "lumir-audio";
  wrap.setAttribute("contenteditable", "false");

  if (props.url) {
    const a = document.createElement("audio");
    a.src = neutralizeUrl(props.url);
    a.controls = true;
    a.setAttribute("controlsList", "nodownload");
    a.addEventListener("contextmenu", (e) => e.preventDefault());
    wrap.appendChild(a);
  } else {
    const ph = document.createElement("div");
    ph.className = "lumir-audio-placeholder";
    ph.textContent = "오디오 URL 없음";
    wrap.appendChild(ph);
  }
  el.appendChild(wrap);
  return el;
}

export function audioElementToBlock(el) {
  const block = {};
  if (el.dataset.id != null) block.id = el.dataset.id;
  block.type = "audio";
  block.props = el.__props || {};
  // 파일형 블록: blocknote 구조상 content 키 없음(no content)
  block.children = el.__children || [];
  return block;
}
